<template>
    <v-container ma-0 pa-0>
        <v-combobox
            contenteditable="true"
            @dragenter="dragEnterTrainingCombo()"
            @dragleave="dragLeaveTrainingCombo()"
            @drop.prevent="dropTrainingCombo()"
            v-bind:class="{ active: isActive }"
            v-model="training"
            :items="get_ListOfTrainings()"
            :label="label"
            prepend-icon="mdi-school"
            append-outer-icon="mdi-water"
            clearable
            chips>
        </v-combobox>
    </v-container>
</template>


<script>
    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../main';


    export default {
        name : 'trainingscombo',

        /* >>> *************************************************************** / /* Props */
        props : {

            value : [ String, null ],
            label : String

        }, // eo props {}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/TrainingsCombo.vue >>> created');
            eventBus.$on('dragendtrainingslist', this.onDragend_InSelectedTrainingsList);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/TrainingsCombo.vue >>> mounted');
            this.set_Training();

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: No need to reset something here.
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/TrainingsCombo.vue >>> beforeDestroy');
            eventBus.$off('dragendtrainingslist', this.onDragend_InSelectedTrainingsList);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> --------------------------
                training: null,
                // >>> --------------------------
                isActive: false, // DnD highligt
                // >>> --------------------------
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            value() {

                this.set_Training();

            }, // eo function value()

            training(value) {

                this.$emit('input', value);

            }, // eo function training()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Trainings',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
            ]),


            /******************************************************************* 'Listeners - Eventbus'
            * Listeners:EventBus:
            *******************************************************************/
            /******************************************************************* 'Trainings - Drop'
            * onDragend_InSelectedTrainingsList()
            *
            * Desc:
            * Note: The small delay is necessary.
            *
            */
            onDragend_InSelectedTrainingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/TrainingsCombo.vue >>> onDragend_InSelectedTrainingsList');
                setTimeout(function(){
                    this.training = params.trainingObject.name; // set dropped itraining name
                }.bind(this), 500);

            }, // eo function onDragend_InSelectedTrainingsList()




            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * set_Training()
            *
            * Desc:
            *
            */
            set_Training: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/TrainingsCombo.vue >>> set_Training');
                me.training = this.value;

            }, // eo function set_Training()




            /*******************************************************************
            * Getters:
            *******************************************************************/
            /*******************************************************************
            * get_ListOfTrainings()
            *
            * Desc: Return List of Trainings.
            * Note:
            *
            */
            get_ListOfTrainings: function() {

                let me = this,
                    trainings = [];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/TrainingsCombo.vue >>> get_ListOfTrainings');
                this.get_Trainings.forEach((training, i) => {
                    trainings.push(training.name);
                });

                return trainings;

            }, // eo function get_ListOfTrainings()




            /******************************************************************* 'Listeners - DnD'
            * Drag&Drop (DnD):
            *******************************************************************/
            /*******************************************************************
            * dragEnterTrainingCombo()
            *
            * Desc:
            * Note:
            *
            */
            dragEnterTrainingCombo: function() {

                this.isActive = true;

            }, // eo function dragEnterTrainingCombo


            /*******************************************************************
            * dragLeaveTrainingCombo()
            *
            * Desc:
            * Note:
            *
            */
            dragLeaveTrainingCombo: function() {

                this.isActive = false;

            }, // eo function dragLeaveTrainingCombo


            /*******************************************************************
            * dropTrainingCombo()
            *
            * Desc:
            * Note:
            * TODO: Some var = true in Case of droped?
            *
            */
            dropTrainingCombo: function() {

                this.isActive = false;

            }, // eo function dropTrainingCombo()

        } // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style>
    /* DnD Background to highlight it */
    .active {
        background-color: #ab3b7a !important;
    }
</style>
